// Claude: New component for specification.md Phase 2 item 4 (§6 decision 6) — a self-service
// Claude: status view for a submitter's own words (backend: /v1/my-suggestions/).
import React, { useState, useEffect, useContext } from "react";
import languageMapper, { baseUrl, getValidAccessToken, statusMapper } from "../shared";
import Logo from "../logo512.png";
import Navbar from "../navbar";
import Navbaranonuser from "../navbaranonuser";
import { AuthContext } from "../context/AuthContext";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../i18n";

const MySuggestions = () => {
  const [mySuggestions, setMySuggestions] = useState([]);
  const [error, setError] = useState(null);
  const { auth } = useContext(AuthContext);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchMySuggestions = async () => {
      const token = await getValidAccessToken();
      try {
        const response = await fetch(baseUrl + "v1/my-suggestions/", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error(`HTTP status ${response.status}`);
        }
        const data = await response.json();
        setMySuggestions(data.my_suggestions);
      } catch (err) {
        console.error("Error:", err);
        // Claude: alpha-tester feedback — "the error message is displayed... but there is no link
        // Claude: to the login page." Same pattern UserRoleManager.js already uses.
        setError(
          <>
            Error fetching your suggestions — please{' '}
            <Link to="/login" className="text-blue-500 underline hover:text-blue-700">log in</Link> again.
          </>
        );
      }
    };

    fetchMySuggestions();
  }, []);

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="min-h-screen bg-gray-100">
      {auth.userName === null && <Navbaranonuser />}
      {auth.userName != null && <Navbar />}

      <div className="flex flex-col justify-center items-center p-2">
        <h3 className="text-4xl font-bold mb-6">
          <Link to={"/"}>{t("my_suggestions")}</Link>
        </h3>
        {mySuggestions.length === 0 && <p>{t("you_havent_submitted")}</p>}
        <table className="border-separate [border-spacing:0.8rem]">
          <thead>
            <tr>
              <th>{t("word")}</th>
              <th>{t("english")}</th>
              <th>{t("language")}</th>
              <th>{t("status")}</th>
            </tr>
          </thead>
          <tbody>
            {mySuggestions.map((word) => (
              <tr key={word._id}>
                <td>{word.word}</td>
                <td>{word.wordEnglish}</td>
                {/* Claude: bugfix found while auditing all language displays (UAT feedback for
                    ReviewQueue.js/DuplicateCleanup.js) — this showed the raw 3-letter language
                    code instead of the full name every other display already uses. */}
                <td>{languageMapper(word.language)}</td>
                <td>{statusMapper(word.status)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex flex-col justify-center items-center p-4">
        <Link to={"/"}>
          <img src={Logo} alt="Logo" width="100" height="100" />
        </Link>
      </div>
    </div>
  );
};

export default MySuggestions;
